{
  "name": "bazilion",
  "version": "0.8.0",
  "description": "Multi-agent runtime CLI — spawn LLM agents, manage profiles/groups/skills, and run the local daemon.",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/rullopat/bazilion.git",
    "directory": "apps/cli"
  },
  "homepage": "https://bazilion.com",
  "bugs": {
    "url": "https://github.com/rullopat/bazilion/issues"
  },
  "keywords": [
    "agent",
    "agents",
    "ai",
    "cli",
    "daemon",
    "llm",
    "local-first",
    "multi-agent",
    "openclaw",
    "skills"
  ],
  "type": "module",
  "bin": {
    "bazilion": "./dist/cli.js"
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ],
  "scripts": {
    "build": "pnpm --filter @bazilion/web build && tsup"
  },
  "engines": {
    "node": ">=24.0.0"
  },
  "publishConfig": {
    "access": "public"
  },
  "dependencies": {
    "@earendil-works/pi-agent-core": "^0.79.10",
    "@earendil-works/pi-ai": "^0.79.10",
    "@earendil-works/pi-coding-agent": "^0.79.10",
    "@hono/node-server": "^2.0.6",
    "@mozilla/readability": "^0.6.0",
    "@tanstack/react-router": "1.170.16",
    "@tobilu/qmd": "^2.5.3",
    "adm-zip": "^0.5.17",
    "citty": "^0.2.2",
    "dompurify": "^3.4.11",
    "grammy": "^1.44.0",
    "hono": "^4.12.26",
    "linkedom": "^0.18.12",
    "lucide-react": "^1.21.0",
    "playwright": "^1.61.0",
    "qrcode-terminal": "^0.12.0",
    "react": "^19.2.7",
    "react-dom": "^19.2.7",
    "typebox": "^1.3.0",
    "undici": "^8.5.0",
    "yaml": "^2.9.0"
  },
  "devDependencies": {
    "@bazilion/api-types": "workspace:*",
    "@bazilion/client": "workspace:*",
    "@types/adm-zip": "^0.5.8",
    "@types/qrcode-terminal": "^0.12.2"
  }
}
